// OpenLayers default rendering order by geometry type (top → bottom).
// Features are drawn last (i.e. on top) in this order, so items earlier in
// the list should appear first in the multi-features list.
const GEOMETRY_TYPE_ORDER = [
  "MultiPolygon",
  "Polygon",
  "LinearRing",
  "Circle",
  "MultiLineString",
  "LineString",
  "MultiPoint",
  "Point",
];

const getGeometryTypeRank = (feature) => {
  const type = feature?.getGeometry?.()?.getType?.();
  const rank = GEOMETRY_TYPE_ORDER.indexOf(type);
  return rank === -1 ? GEOMETRY_TYPE_ORDER.length : rank;
};

const getZIndex = (feature) => {
  const zIndex = feature?.get?.("zIndex");
  return Number.isFinite(zIndex) ? zIndex : 0;
};

// Sort features so higher zIndex is on top; ties are broken by OL's default
// geometry-type order (Point first, MultiPolygon last).
export const sortFeaturesByZIndexAndGeom = (a, b) => {
  const zDiff = getZIndex(a) - getZIndex(b);
  if (zDiff !== 0) {
    return zDiff;
  }
  const typeDiff = getGeometryTypeRank(a) - getGeometryTypeRank(b);
  if (typeDiff !== 0) {
    return typeDiff;
  }
  return a.ol_uid - b.ol_uid; // Preserve original creation order for otherwise-equal features.
};

export default sortFeaturesByZIndexAndGeom;
